export default __webpack_public_path__ + "static/kenshinBana-618778246a55a75407a1a98c6c9e1237.png";